export default "__VITE_ASSET__BzlaILix__"